// /hooks/useTranslation.js
import { useState, useEffect } from 'react';


const languageData = {

  reservationAndPayment: {
    en: {
      checkin: "Check-in:",
      checkout: "Check-out:",
      totalNights: "Total Nights:",
      subtotal: "Subtotal:",
      name: "Name:",
      email: "Email:",
      paymentSucess: "<p><strong>Thank you!</strong> Your payment was successful.</p> \
              <p>You will receive a confirmation email with the reservation details shortly.</p> \
              <p>You can now close this window.</p>",

    },
    es: {
      checkin: "Entrada:",
      checkout: "Salida:",
      totalNights: "Número de noches:",
      subtotal: "Subtotal:",
      name: "Nombre:",
      email: "Correo electrónico:",
      paymentSucess: "<p><strong>¡Gracias!</strong> Tu pago se ha realizado correctamente.</p> \
       <p>En breve recibirás un correo de confirmación con los detalles de la reserva.</p> <p>Ahora puedes cerrar esta ventana.</p>"

    },
    ca: {
      checkin: "Entrade:",
      checkout: "Sortida:",
      totalNights: "Nombre de nits:",
      subtotal: "Subtotal:",
      name: "Nom:",
      email: "Correo Electrònic:",
      paymentSucess: "<p><strong>Gràcies!</strong> El teu pagament s'ha realitzat correctament.</p> \
<p>Aviat rebràs un correu de confirmació amb els detalls de la reserva.</p> \
<p>Ara pots tancar aquesta finestra.</p>"

    },
    pl: {
      checkin: "Zameldować się:",
      checkout: "Wymeldować się:",
      totalNights: "Liczba nocy:",
      subtotal: "Suma Częściowa:",
      name: "Nazwa:",
      email: "E-mail:",
      paymentSucess: "<p><strong>Dziękujemy!</strong> Płatność zakończona sukcesem.</p> <p>Wkrótce otrzymasz e-mail \
       z potwierdzeniem i szczegółami rezerwacji.</p><p>Możesz teraz zamknąć to okno.</p>"
    },

  },

  amenities: {
    en: {
      wifi: "WiFi",
      cutlery: "Cutlery",
      washmachine: "Washing Machine",
      bath: "Bath",
      parking: "Parking",
      airConditioning: "Air Conditioning"
    },
    es: {
      wifi: "WiFi",
      cutlery: "Cubiertos",
      washmachine: "Lavadora",
      bath: "Bañera",
      parking: "Aparcamiento",
      airConditioning: "Aire Acondicionado"
    },
    ca: {
      wifi: "WiFi",
      cutlery: "Estris de cuina",
      washmachine: "Rentadora",
      bath: "Banyera",
      parking: "Aparcament",
      airConditioning: "Aire condicionat"
    },
    pl: {
      wifi: "WiFi",
      cutlery: "Sztućce",
      washmachine: "Pralka",
      bath: "Wanna",
      parking: "Parking",
      airConditioning: "Klimatyzacja"
    }
  },
  calendar: {
    en: {
      title: "Book Your Stay Now!",
      checkin: "Check In",
      checkout: "Check Out",
      book: "Book Now",
    },

    es: {
      title: "¡Reserve su estancia ahora!",
      checkin: "Entrada",
      checkout: "Salida",
      book: "Reserve Ahora",
    },
    ca: {
      title: "Reserva ara la teva estada!",
      checkin: "Entrade",
      checkout: "Sortida",
      book: "Reserva Ara",
    },
    pl: {
      title: "Zarezerwuj swój pobyt już teraz!",
      checkin: "Wejście",
      checkout: "Wyjście",
      book: "Zarezerwuj teraz",

    }
  },

  features: {
    en: {
      title: "Features",
      content: "We have everything essential to enjoy and relax during your stay."
    },
    es: {
      title: "Características",
      content: "Tenemos todo lo esencial para disfrutar y relajar durante la estancia."
    },
    ca: {
      title: "Característiques",
      content: "Tenim tot allò essencial per gaudir i relaxar durant l'estada."
    },
    pl: {
      title: "Charakterystyka",
      content: "Mamy wszystko, co niezbędne, aby cieszyć się i zrelaksować podczas pobytu."

    }
  },

  contact: {
    en: {
      title: "Contact",
      content: "You can contact us through this form or Whatsapp."
    },

    es: {
      title: "Contacto",
      content: "Puedes contactarnos a través de este formulario o Whatsapp."
    },
    ca: {
      title: "Contacte",
      content: "Pots contactar amb nosaltres mitjançant aquest formulari o Whatsapp."
    },
    pl: {
      title: "Kontakt",
      content: "Możesz się z nami skontaktować za pomocą tego formularza lub WhatsApp."

    }
  },
  contactForm: {
    en: {
      name: "Name",
      email: "E-mail",
      message: "Message",
      sendEmail: "Send message"
    },

    es: {
      name: "Nombre",
      email: "Correo electrónico",
      message: "Mensaje",
      sendEmail: "Enviar mensaje"
    },

    ca: {
      name: "Nom",
      email: "Correu electrònic",
      message: "Missatge",
      sendEmail: "Enviar missatge"
    },

    pl: {
      name: "Imię",
      email: "E-mail",
      message: "Wiadomość",
      sendEmail: "Wyślij wiadomość"
    }
  },

  location: {
    en: {
      title: "Location",
      content: "Located in a peaceful and stunning place."
    },

    es: {
      title: "Ubicación",
      content: "Situado en un lugar tranquilo y espectacular."
    },
    ca: {

      title: "Ubicació",
      content: "Situat en un lloc tranquil i espectacular."
    },
    pl: {
      title: "Lokalizacja",
      content: "Położony w cichym i malowniczym miejscu."

    }
  },
  welcome: {
    en: {
      title: "About the house",
      introduction: "Hi, and welcome! We’re a small, close-knit family—We are me (a Software Developer), my spouse, our energetic three-year-old daughter Aleksandra :), and our sweet little dog. We’ve poured our heart into creating this cozy home, but as life takes us elsewhere for a while, we’re thrilled to rent it out so that you can enjoy it, too. I’ve built this site to make it easy for you to book and get to know our place (and for not to pay airbnb commissions), although you’ll also find us on <a href=\"https://airbnb.es/h/villaaleksandra\" target=\"_blank\">Airbnb</a> and <a href=\"https://www.booking.com/hotel/es/villa-aleksandra-benicassim\" target=\"_blank\">Booking.com</a> if you prefer. If you have any questions or need any help during your stay, don’t hesitate to reach out. We can’t wait to share our home with you and hope you’ll love it here as much as we have. Please read out our <a href=\"terms\">Terms & Conditions</a> before making any reservations."
    },
    es: {
      title: "Sobre la casa",
      introduction: "Hola y bienvenidos! Somos una familia pequeña y unida: yo (Desarrollador de Software), mi esposa, nuestra enérgica hija Aleksandra de tres años :) y nuestro adorable perrito. Nos hemos dedicado por completo a crear este acogedor hogar, pero como la vida nos lleva a otro lugar por un tiempo, estamos encantados de alquilarlo para que ustedes también puedan disfrutarlo. He creado este sitio web para que les sea fácil reservar y conocer nuestro alojamiento (y para no pagar comisiones de Airbnb), aunque también pueden encontrarnos en <a href=\"https://airbnb.es/h/villaaleksandra\" target=\"_blank\">Airbnb</a> y <a href=\"https://www.booking.com/hotel/es/villa-aleksandra-benicassim\" target=\"_blank\">Booking.com</a> si lo prefieren. Si tienen alguna pregunta o necesitan ayuda durante su estancia, no duden en contactarnos. ¡Estamos deseando compartir nuestro hogar con ustedes y esperamos que les guste tanto como a nosotros! Por favor, lea los <a href=\"terms\">Términos y Condiciones</a> antes de realizar cualquier reserva.",
    },
    ca: {
      title: "Sobre la casa",
      introduction: "Hola, i benvinguts! Som una família petita i unida: som jo (un desenvolupador de programari), el meu cònjuge, la nostra enèrgica filla Aleksandra de tres anys :) i el nostre dolç gosset. Hem posat el cor per crear aquesta casa acollidora, però com que la vida ens porta a un altre lloc durant un temps, estem encantats de llogar-la perquè tu també la puguis gaudir. He creat aquest lloc per facilitar-te la reserva i el coneixement del nostre lloc (i per no pagar comissions d'airbnb), encara que també ens trobaràs a <a href=\"https://airbnb.es/h/villaaleksandra\" target=\"_blank\">Airbnb</a> i <a href=\"https://www.booking.com/hotel/es/villa-aleksandra-benicassim\" target=\"_blank\">Booking.com</a> si ho prefereixes. Si tens cap pregunta o necessites ajuda durant la teva estada, no dubtis a posar-te en contacte. Estem impacients per compartir la nostra casa amb vosaltres i esperem que us agradi tant com a nosaltres! Si us plau, llegiu els <a href=\"terms\">termes i condicions</a> abans de fer qualsevol reserva.",
    },
    pl: {
      title: "O domu",
      introduction: "Cześć i witaj! Jesteśmy małą, zżytą rodziną — ja (programista), mój małżonek, nasza energiczna trzyletnia córka Aleksandra :) i nasz słodki piesek. Włożyliśmy całe serce w stworzenie tego przytulnego domu, ale ponieważ życie zabiera nas gdzie indziej na jakiś czas, jesteśmy podekscytowani, że możemy go wynająć, abyś i Ty mógł się nim cieszyć. Stworzyłem tę stronę, aby ułatwić Ci rezerwację i poznanie naszego miejsca (i aby nie płacić prowizji Airbnb ), chociaż znajdziesz nas również na <a href=\"https://airbnb.es/h/villaaleksandra\" target=\"_blank\">Airbnb</a> i <a href=\"https://www.booking.com/hotel/es/villa-aleksandra-benicassim\" target=\"_blank\">Booking.com</a> jeśli wolisz. Jeśli masz jakieś pytania lub potrzebujesz pomocy podczas pobytu, nie wahaj się skontaktować z nami. Nie możemy się doczekać, aby podzielić się z Tobą naszym domem i mamy nadzieję, że pokochasz go tak samo jak my! Przed dokonaniem <a href=\"terms\">rezerwacji prosimy</a> o zapoznanie się z Regulaminem.",
    }
  },
  menu: {
    en: {
      about: "About",
      location: "Location",
      features: "Features",
      contact: "Contact"
    },
    es: {
      about: "Nosotros",
      location: "Ubicación",
      features: "Características",
      contact: "Contacto"
    },
    ca: {
      about: "Nosaltres",
      location: "Ubicació",
      features: "Característiques",
      contact: "Contacte"
    },
    pl: {
      about: "O&nbspNas",
      features: "Udogodnienia ",
      location: "Lokalizacja",
      contact: "Kontakt"
    }
  },
  footer: {
    en: {
      rights: "All rights reserved.",
      terms: "Terms and Conditions"
    },
    es: {
      rights: "Todos los derechos reservados.",
      terms: "Términos y Condiciones"
    },

    ca: {
      rights: "Tots els drets reservats.",
      terms: "Termes i Condicions"
    },
    pl: {
      rights: "Wszelkie prawa zastrzeżone.",
      terms: "Regulamin"
    }
  }

  };


  function resolvePath(obj, path) {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function useTranslation(defaultLang = 'es', fallbackLang = 'es') {
  const [lang, setLangState] = useState(() => {

    return localStorage.getItem('lang') || defaultLang;
  });

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  const setLang = (newLang) => {
    setLangState(newLang);
  };

  const t = (key) => {
    const [section] = key.split('.');
    const subKey = key.replace(`${section}.`, '');
    const value = resolvePath(languageData[section]?.[lang], subKey);
    if (value) return value;
    const fallbackValue = resolvePath(languageData[section]?.[fallbackLang], subKey);
    return fallbackValue || '';
  };

  return { t, lang, setLang };
}